import React from "react";
import {useTranslation} from "react-i18next";

import MDBox from "../../../materialDashboard/components/MDBox";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import MDInput from "../../../materialDashboard/components/MDInput";

import Stack from "@mui/material/Stack";


const NotesSection = ({formik}) => {
    const {t} = useTranslation(['stations']);

    return <Stack spacing={1}>
        <MDBox>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                {t('stationForm.notes')}
            </MDTypography>
        </MDBox>
        <MDInput name="notes"
                 value={formik.values.notes}
                 onChange={formik.handleChange}
                 error={formik.touched.notes && Boolean(formik.errors.notes)}
                 helperText={formik.touched.notes && formik.errors.notes}
                 variant="standard"
                 fullWidth
                 multiline
                 rows={4}
        />
    </Stack>
}

export default NotesSection;